import { Button, Chip, Stack, Dialog, DialogActions, DialogContent, DialogTitle, Fab, Grid, IconButton, Paper, Typography, TextField, LinearProgress } from "@mui/material";
import { useContext, useState } from "react";
import moment from "moment";
import SelectInput from "../ui/SelectInput";
import { CheckBox, CheckBoxOutlineBlank, Clear, Delete, FileUpload, IndeterminateCheckBox, Search } from "@mui/icons-material";
import $data from "../../services/$data";
import { DataContext } from "../DataContext";
import { AppContext } from "../../AppContext";


const tagsValues = {
  'None': 'None',
  'Red zone - Row': 'R_R',
  'Red zone - Between rows': 'B_R',
  'Green zone - Row': 'R_G',
  'Green zone - Between rows': 'B_G',
  'Yellow zone - Row': 'R_Y',
  'Yellow zone - Between rows': 'B_Y',
  'Witness': 'W',
  'Applicability': 'AP',
  'Fertilization': 'F',
  'Pesticides': 'PE',
  'Soil management': 'S',
  'Pruning': 'PR',
  'Harvesting': 'H',
  'Resiudes management': 'RM',
  'Irrigation': 'I',
  'Animals': 'AN',
  'Soil Organic Carbon': 'SOC',
  'Planting': 'PL',
  'Biomass Management': 'BM',
};

const tagsLabels = {
  'None': 'None',
  'R_R': 'Red zone - Row',
  'B_R': 'Red zone - Between rows',
  'R_G': 'Green zone - Row',
  'B_G': 'Green zone - Between rows',
  'R_Y': 'Yellow zone - Row',
  'B_Y': 'Yellow zone - Between rows',
  'W': 'Witness',
  'AP': 'Applicability',
  'F': 'Fertilization',
  'PE': 'Pesticides',
  'S': 'Soil management',
  'PR': 'Pruning',
  'H': 'Harvesting',
  'RM': 'Resiudes management',
  'I': 'Irrigation',
  'AN': 'Animals',
  'SOC': 'Soil Organic Carbon',
  'PL': 'Planting',
  'BM': 'Biomass Management',
}

function UploadDocumentModal({ tags = Object.keys(tagsLabels).map(t => ({ value: t, label: tagsLabels[t] })), tag, parcel, year, open, onClose, withoutSOC = false }) {
  const {onGetDocuments} = useContext(DataContext);
  const {selected} = useContext(AppContext);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [state, setState] = useState({
    title: '',
    year: year,
    tag: tag || undefined,
    parcel: parcel,
    files: []
  });

  const handleFileChange = (event) => {
    let files = [];
    Array.from(event.target.files).forEach(file => {
      files.push(file)
    })

    setState(current => ({...current, files}))
  }

  const onSubmit = async () => {
    setError('');
    setLoading(true);
    try {
      let result = await $data.uploadFiles(state);
      if(result.errors?.length > 0) {
        setError(result.errors.map(e => e).join('. '))
      } else {
        onClose();  
      }
      onGetDocuments(selected);

    } catch(e) {
      console.log(e)
      onGetDocuments(selected);
      setError(e?.errors?.map(err => err)?.join('\n'));
    } finally {
      setLoading(false);
      setState(current => ({...current, files: []}));
      document.querySelector('#documents-upload').value = ''
    }
  }

  const formatedTags = tags.filter(t => {
    if (withoutSOC) {
      return t.value !== 'None' && t.value !== 'AP' && t.value.indexOf('_') === -1 && t.value !== 'W' && t.value !== 'SOC' && t.value !== 'BM';
    }
    return true;
  })

  return (
    <Dialog PaperProps={{ className: 'co-background-white' }} fullWidth maxWidth="lg" open={open} onClose={onClose}>

      <DialogTitle color="primary">Upload document</DialogTitle>
      <DialogContent>
        <Grid container spacing={2} sx={{ mt: '20px' }}>
          {error && <Grid item xs={12}>
            <Typography variant="h6" color="error">{error}</Typography>
          </Grid>}
          <Grid item xs={12} sm={6} md={4}>
            <TextField value={state.title} onChange={(e) => setState(current => ({...current, title: e.target.value}))} label="Folder name" helperText="This will be used as a folder/category name e.g. Fuel Consumption Documents" fullWidth size="small" />
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <SelectInput value={state.tag} onChange={(e) => setState(current => ({...current, tag: e.target.value}))} items={formatedTags} name="Tag" />
          </Grid>

          <Grid item xs={12}>
            <Stack direction="row" alignItems="center" spacing={2}>
            <Button
              component="label"
              role={undefined}
              variant="contained"
              tabIndex={-1}
              startIcon={<FileUpload />}
            >
              Select file(s)
              <input
                id="documents-upload"
                style={{visibility: 'hidden', height: '0px', width: '0px'}}
                type="file"
                onChange={handleFileChange}
                multiple
                accept="application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, image/jpg, image/jpeg, image/png"
              />
            </Button>
            {state.files.length > 0 && <IconButton onClick={() => setState(current => ({...current, files: []}))} color="error">
              <Delete />
            </IconButton>}
            </Stack>
          </Grid>
          {state.files.length > 0 && state.files.map((file,index) => (
            <Grid item xs={12} key={index}>
              <Typography>{file.name}</Typography>
            </Grid>
          ))}
        </Grid>

      </DialogContent>
      <DialogActions>
        <Button onClick={onSubmit} disabled={!state.title || !state.tag || state.files.length === 0} style={{ lineHeight: 'unset' }} variant="contained" color="primary" >Submit</Button>
        <Button style={{ lineHeight: 'unset' }} color="error" onClick={onClose}>Cancel</Button>

      </DialogActions>
      {loading && <LinearProgress color="primary" />}
    </Dialog>
  )
}

export default UploadDocumentModal;